<div class="flex h-full min-h-0 w-full flex-col overflow-hidden">
  <header class="shrink-0 border-b border-zinc-200 pb-4 dark:border-zinc-800">
    <div class="flex flex-wrap items-start justify-between gap-4">
      <div class="min-w-0">
        <h2 class="m-0 text-lg font-semibold text-zinc-900 dark:text-zinc-100">Emails</h2>
        <p class="m-0 mt-1 text-sm text-zinc-500 dark:text-zinc-400">
          Every transactional email SHOUT sends. Previews use sample data — nothing is sent.
        </p>
      </div>

      <button
        type="button"
        class="rounded-lg border border-zinc-300 bg-white px-2.5 py-1.5 text-xs font-medium text-zinc-800 hover:bg-zinc-50 disabled:opacity-50 dark:border-zinc-600 dark:bg-zinc-900 dark:text-zinc-100 dark:hover:bg-zinc-800"
        [disabled]="loadingState() === 'loading'"
        (click)="loadCatalog()"
      >
        Refresh
      </button>
    </div>

    @if (loadingState() === 'loaded') {
    <div class="mt-4 flex flex-wrap gap-2" role="tablist" aria-label="Email groups">
      @for (tab of tabs(); track tab.id) {
      <button
        type="button"
        role="tab"
        class="rounded-lg border px-3 py-1.5 text-sm font-medium transition-colors"
        [class]="getTabClass(tab.id)"
        [attr.aria-selected]="isTabSelected(tab.id)"
        (click)="selectTab(tab.id)"
      >
        {{ tabLabel(tab) }}
      </button>
      }
    </div>
    }
  </header>

  <div class="min-h-0 flex-1 overflow-y-auto pt-5 scrollbar-transparent">
    @if (loadingState() === 'loading' || loadingState() === 'idle') {
    <p class="m-0 text-sm text-zinc-500 dark:text-zinc-400" role="status">Loading emails…</p>
    } @else if (loadingState() === 'error') {
    <div
      class="rounded-xl border border-red-200 bg-red-50 p-4 dark:border-red-900 dark:bg-red-950/40"
      role="alert"
    >
      <p class="m-0 text-sm font-medium text-red-800 dark:text-red-200">Couldn’t load emails</p>
      <p class="m-0 mt-1 text-sm text-red-700 dark:text-red-300">{{ loadError() }}</p>
      <button
        type="button"
        class="mt-3 rounded-lg border border-red-300 bg-white px-2.5 py-1.5 text-xs font-medium text-red-800 hover:bg-red-50 dark:border-red-800 dark:bg-red-950 dark:text-red-100 dark:hover:bg-red-900"
        (click)="loadCatalog()"
      >
        Try again
      </button>
    </div>
    } @else if (tabs().length === 0) {
    <p class="m-0 text-sm text-zinc-500 dark:text-zinc-400" role="status">No emails found.</p>
    } @else if (activeTab(); as tab) {
    <div class="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4">
      @for (email of tab.emails; track email.id) {
      <article
        class="flex flex-col overflow-hidden rounded-xl border border-zinc-200 bg-white dark:border-zinc-800 dark:bg-zinc-950"
      >
        <div
          class="emails-preview"
          (click)="openPreview(email)"
          (keydown.enter)="openPreview(email)"
          role="button"
          tabindex="0"
          [attr.aria-label]="'Preview ' + email.name"
        >
          @if (iframeUrl(email.id); as src) {
          <iframe [src]="src" title="{{ email.name }} preview" tabindex="-1"></iframe>
          } @else {
          <p class="m-0 px-3 text-xs text-zinc-500 dark:text-zinc-400">
            {{ previewLoading() ? 'Loading preview…' : 'Preview unavailable' }}
          </p>
          }
        </div>

        <div class="flex flex-1 flex-col gap-3 p-3">
          <div>
            <h3 class="m-0 text-sm font-semibold text-zinc-900 dark:text-zinc-100">{{ email.name }}</h3>
            <p class="m-0 mt-1 line-clamp-2 text-xs text-zinc-500 dark:text-zinc-400">
              {{ email.description }}
            </p>
          </div>

          <div class="flex flex-wrap items-center gap-1.5">
            <p class="m-0 rounded bg-zinc-100 px-1.5 py-0.5 text-xs text-zinc-600 dark:bg-zinc-900 dark:text-zinc-300">
              {{ email.audience }}
            </p>
            <p class="m-0 rounded bg-zinc-100 px-1.5 py-0.5 text-xs text-zinc-600 dark:bg-zinc-900 dark:text-zinc-300">
              {{ styleLabel(email.style) }}
            </p>
            <p
              class="m-0 rounded-full border px-2 py-0.5 text-xs font-semibold tracking-wide"
              [class]="
                email.inUse
                  ? 'border-emerald-200 bg-emerald-50 text-emerald-800 dark:border-emerald-800 dark:bg-emerald-950 dark:text-emerald-200'
                  : 'border-zinc-300 bg-zinc-50 text-zinc-700 dark:border-zinc-600 dark:bg-zinc-900 dark:text-zinc-200'
              "
            >
              {{ email.inUse ? 'Live' : 'Unused' }}
            </p>
          </div>

          <p class="m-0 line-clamp-2 text-xs text-zinc-500 dark:text-zinc-400">
            <span class="font-medium text-zinc-700 dark:text-zinc-300">Subject:</span>
            {{ email.subject }}
          </p>

          <div class="mt-auto flex flex-wrap gap-2 pt-1">
            <button
              type="button"
              class="inline-flex items-center justify-center rounded-lg border border-zinc-900 bg-zinc-900 px-2.5 py-1.5 text-xs font-medium text-white hover:bg-zinc-800 dark:border-zinc-100 dark:bg-zinc-100 dark:text-zinc-900 dark:hover:bg-white"
              (click)="openPreview(email)"
            >
              Preview
            </button>
            <button
              type="button"
              class="inline-flex items-center justify-center rounded-lg border border-zinc-300 bg-white px-2.5 py-1.5 text-xs font-medium text-zinc-800 hover:bg-zinc-50 dark:border-zinc-600 dark:bg-zinc-900 dark:text-zinc-100 dark:hover:bg-zinc-800"
              (click)="copySubject(email)"
            >
              {{ isCopied(email) ? 'Copied' : 'Copy subject' }}
            </button>
          </div>
        </div>
      </article>
      }
    </div>
    }
  </div>
</div>

<app-dialog [open]="previewOpen()" (closed)="closePreview()">
  <div dialog-header>
    <h3 class="m-0 text-base font-semibold text-zinc-900 dark:text-zinc-100">
      {{ selectedEmail()?.name }}
    </h3>
    <p class="m-0 mt-1 text-sm text-zinc-500 dark:text-zinc-400">{{ selectedEmail()?.subject }}</p>
  </div>
  <div dialog-body>
    @if (selectedEmail(); as email) {
    @if (iframeUrl(email.id); as src) {
    <iframe class="emails-preview-full" [src]="src" [title]="email.name"></iframe>
    } @else {
    <p class="m-0 text-sm text-zinc-500 dark:text-zinc-400">Loading preview…</p>
    }
    }
  </div>
</app-dialog>
